<div class="catalogue-wrapper">
  <div class="d-flex justify-space-between mt-3 mb-3">
    <div>
      <img alt="back" (click)="handleBack()" class="cursor"
        src="../../../../assets/images/arrow_circle_left.svg" />&nbsp;
      <span class="catalogue-title">Catalogue</span>
    </div>
    <div>
      <form [formGroup]="datepickerForm">
        <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'"
          [autoApply]="false" [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true"
          [timePickerSeconds]="true" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true"
          [keepCalendarOpeningWithRange]="true" [opens]="'left'" (datePassed)="saveTime($event)">
        </app-datetime-range>
      </form>
    </div>
  </div>

  <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedTabIndex">
    <mat-tab label="{{tab.label}}" *ngFor="let tab of catalogueTabList;let i = index">
      <div [ngSwitch]="tab?.id">
        <div *ngSwitchCase="'overview'">
          <div class="grid-container">
            <div class="card card1" (click)="switchTab(1)">
              <div class="pad12">
                <div>
                  <img alt="dot" src="../../../../assets/images/dot_circle.svg" />&nbsp;
                  <span class="card-title">Vehicle Configuration</span>
                </div>
                <div class="make-responsive-card-details">
                  <div *ngFor="let detail of vehicleConfigurationsList">
                    <div class="info-row">
                      <div class="label">{{ detail?.label }}</div>
                      <div class="value">{{ detail?.value ?? '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card2" (click)="switchTab(2)">
              <div class="pad12">
                <div>
                  <img alt="point" src="../../../../assets/images/flower_bullet_point.svg" />&nbsp;
                  <span class="card-title">Features</span>
                </div>
                <div class="make-responsive-card-details">
                  <div *ngFor="let detail of featuresList">
                    <div class="info-row">
                      <div class="label">{{ detail?.label }}</div>
                      <div class="value">{{ detail?.value ?? '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card3" (click)="switchTab(3)">
              <div class="pad12">
                <div>
                  <img alt="point" src="../../../../assets/images/flower_bullet_point.svg" />&nbsp;
                  <span class="card-title">Domain ECU</span>
                </div>
                <div class="make-responsive-card-details">
                  <div *ngFor="let detail of domainEcuList">
                    <div class="info-row">
                      <div class="label">{{ detail?.label }}</div>
                      <div class="value">{{ detail?.value ?? '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card4" (click)="switchTab(4)">
              <div class="pad12">
                <div>
                  <img alt="point" src="../../../../assets/images/flower_bullet_point.svg" />&nbsp;
                  <span class="card-title">Network Topology</span>
                </div>
                <div class="make-responsive-card-details">
                  <div *ngFor="let detail of networkTopologyList">
                    <div class="info-row">
                      <div class="label">{{ detail?.label }}</div>
                      <div class="value">{{ detail?.value ?? '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card5" (click)="switchTab(5)">
              <div class="pad12">
                <div>
                  <img alt="back" class="cursor" src="../../../../assets/images/flower_bullet_point.svg" />&nbsp;
                  <span class="card-title">Artifacts</span>
                </div>
                <div class="make-responsive-card-details">
                  <div *ngFor="let detail of artifactsList">
                    <div class="info-row">
                      <div class="label">{{ detail?.label }}</div>
                      <div class="value">{{ detail?.value ?? '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card6">
              <div class="pad12">
                <div>
                  <span class="card-title">History</span>
                </div>
                <app-catalogue-history [tabType]="'overview'" [historyData]="historyData"></app-catalogue-history>
              </div>
            </div>
          </div>

        </div>
        <div *ngSwitchCase="'vehicleConfig'">
          <div class="card">
            <div class="config-wrapper">
              <div class="mt-3">
                <span class="config-title">Vehicle Configuration</span>
              </div>
              <div class="config-bg">
                <div>
                  <img alt="dot" src="../../../../assets/images/dot_circle.svg" />&nbsp;
                  <span class="card-title">Vehicle Configuration</span>
                </div>
                <div class="make-responsive-config-details">
                  <div *ngFor="let detail of vehicleConfigurationsList">
                    <div class="info-row">
                      <div class="label">{{ detail?.label }}</div>
                      <div class="value">{{ detail?.value ?? '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'features'">
          <app-accordian-expansion-panel [panelData]="catalogueConfig?.featuresPanelData" [cardHeader]="tab.label"
            [tabType]="'features'" [routeData]="routeData"></app-accordian-expansion-panel>
        </div>
        <div *ngSwitchCase="'domainECU'">
          <app-accordian-expansion-panel [panelData]="catalogueConfig?.domainEcuPanelData" [cardHeader]="tab.label"
            [tabType]="'domainECU'"></app-accordian-expansion-panel>
        </div>
        <div *ngSwitchCase="'networkTopology'">
          <div class="card">
            <div class="mt-3 d-flex justify-space-between align-items-center">
              <span class="card-title">Network Topology</span>
              <div class="d-flex gap-10">
                <div class="sb-border">
                  <mat-form-field>
                    <select matNativeControl disabled>
                      <option value="2024_v1.1">2025_v1.01</option>
                    </select>
                  </mat-form-field>
                </div>
                <div class="sb-border">
                  <mat-form-field>
                    <select matNativeControl disabled>
                      <option value="Master">Master</option>
                    </select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <img alt="topology" [src]="topologyUrl" class="topology-padding" />
          </div>
        </div>
        <div *ngSwitchCase="'artifacts'">
          <div class="card">
            <mat-tab-group (selectedTabChange)="artifactsTabChanged($event)"
              [selectedIndex]="selectedArtifactsTabIndex">
              <mat-tab label="{{tab?.label}}" *ngFor="let tab of artifactsTabList; let index = index">
                <div [ngSwitch]="tab?.id">
                  <div *ngSwitchCase="'vehicleArtifacts'">
                    <app-common-table [tableData]="catalogueConfig?.artifactsTableData"
                      [pageType]="'catalogue-artifact'" [columnHeader]="catalogueConfig?.artifactsColumHeader"
                      class="app-common-table" [actionPermission]="{pagination:false, catalogueDownload:true}"
                      (tableAction)="tableAction($event)"></app-common-table>
                  </div>
                  <div *ngSwitchCase="'diagnostics'">
                    <app-common-table [tableData]="catalogueConfig?.diagnosticsTableData"
                      [pageType]="'catalogue-artifact'" [columnHeader]="catalogueConfig?.diagnosticsColumnHeader"
                      class="app-common-table" [actionPermission]="{pagination:false,catalogueDownload:true}"
                      (tableAction)="tableAction($event)"></app-common-table>
                  </div>
                  <div *ngSwitchCase="'others'">
                    <app-common-table [tableData]="catalogueConfig?.othersTableData" [pageType]="'catalogue-artifact'"
                      [columnHeader]="catalogueConfig?.othersColumnHeader" class="app-common-table"
                      [actionPermission]="{pagination:false,catalogueDownload:true}"
                      (tableAction)="tableAction($event)"></app-common-table>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
        <div *ngSwitchCase="'history'">
          <div class="card w-53">
            <div class="pad12">
              <div>
                <span class="card-title">History</span>
              </div>
              <app-catalogue-history [tabType]="'history'" [historyData]="historyData"></app-catalogue-history>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>